import { useMutation } from "@apollo/client";
import { CreateOrderFromExternalCaseDocument } from "../../gql/generated/graphql";

export const useCreateOrder = () => {
  const [createOrderFromExternalCase] = useMutation(
    CreateOrderFromExternalCaseDocument
  );

  return {
    createOrderFromExternalCase: createOrderFromExternalCase,
  };
};
